import { useEffect, useState } from 'react';
import {
  OrderListType,
  orderToVerifyAddressListGetApi,
} from '../../api/apiConfig';
import useFetch from '../../api/useFetch';
import styled from 'styled-components';
import { formatEightDigitStringToSixDigitDot } from '../../function/replaceString';

type OrderWithDescription = {
  order: OrderListType;
  description: string;
};

export const AddressVerifyPreview = () => {
  const [data, setData] = useState<OrderWithDescription[]>([]);
  const { fetch: fetchOrderToVerifyAddressListGetApi } = useFetch({
    fetchFunction: orderToVerifyAddressListGetApi,
    onSuccess: (data: OrderListType[]) => {
      initData(data);
    },
  });
  useEffect(() => {
    fetchOrderToVerifyAddressListGetApi();
  }, []);

  function initData(data: OrderListType[]) {
    const listArray: OrderWithDescription[] = [];
    data.forEach((order) => {
      const custDes = order.CUST_DES;
      const itemDes = order.subRows ? order.subRows[0].PROD_DES : '';
      const otherString =
        order.subRows && order.subRows.length > 1
          ? `외 ${order.subRows.length}건`
          : '';
      const description = `[${custDes}] ${itemDes}${otherString}`;
      const item: OrderWithDescription = {
        order: order,
        description: description,
      };
      listArray.push(item);
    });
    setData(listArray);
  }
  return (
    <Container>
      {data.length > 0 ? (
        <>
          <Row>
            <div className='des'>주문정보</div>
            <div className='count'>주문일자</div>
          </Row>

          <BodyContainer>
            {data.map((order) => (
              <>
                <BodyRow>
                  <div className='des'>{order.description}</div>
                  <div className='count'>
                    {formatEightDigitStringToSixDigitDot(order.order.IO_DATE!)}
                  </div>
                </BodyRow>
              </>
            ))}
          </BodyContainer>
        </>
      ) : (
        <StyledH4>검증이 필요한 항목이 없습니다</StyledH4>
      )}
    </Container>
  );
};

const StyledH4 = styled.h4`
  margin: 0;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 29px;
  font-weight: 600;
  font-size: 12px;
  margin-top: 7px;

  .des {
    flex: 1 0 50%;
    text-align: start;
    padding-left: 15px;
    overflow: hidden; /* 넘치는 부분 숨김 */
    text-overflow: ellipsis; /* 가려지는 부분 ... 처리 */
    white-space: nowrap; /* 줄 넘김 금지 */
  }
  .count {
    flex: 0 0 18%;
    text-align: center;
  }
`;

const BodyContainer = styled.div`
  height: 210px;
  /* background-color: #f0f0f0; */
  border-top: 1px solid #cccccc7d;
  border-bottom: 1px solid #cccccc7d;
  margin-top: 7px;
  overflow-y: scroll;
`;

const BodyRow = styled(Row)`
  border-bottom: 1px solid #cccccc7d;
  margin-top: 0px;
  font-weight: 500;
`;
